import { Button, Empty, message, Space, Table, DatePicker } from "antd";
import React, { useState, useEffect } from "react";
import useTableSearch from "../../hooks/useTableSearch";
import moment from "moment";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../constants";
import dayjs from "dayjs";

export const Downloads = ({ setEditTarif, tarifs }) => {
  const getColumnSearchProps = useTableSearch();
  const [customers, setCustomers] = useState([]);
  const [date, setDate] = useState(dayjs().subtract(1, "month"));
  const accessToken = useSelector(
    (state) => state.user.currentUser?.accessToken
  );
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [jobKey, setJobKey] = useState(null);
  const [status, setStatus] = useState(null);
  const [percentage, setPercentage] = useState(null);

  const getCustomers = async () => {
    try {
      const res = await axios.get(`${API_URL}user/customers/invoices/${date.year()}/${date.month() + 1}`, {
        headers: { Authorization: "Bearer " + accessToken },
      });

      setCustomers(res.data);
      setLoading(false);
    } catch (error) {
      console.log({ error });
      setLoading(false);
    }
  };

  useEffect(() => {
    // if (!jobKey) return;
    const interval = setInterval(async () => {
      const res = await fetch(
        API_URL +
          `gestionar/invoice/status/${
            jobKey || `invoice_progress:${date.month() + 1}_${date.year()}`
          }`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      const data = await res.json();
      if (data.status === "in_progress" && data.total) {
        if (!status) {
          setStatus(data.status);
        }
        setPercentage(((data.done / data.total) * 100).toFixed(2));
      }
      if (
        !jobKey &&
        (data.status === "not_found" || data?.total === data?.done)
      ) {
        clearInterval(interval);
        setPercentage(null);
        return;
      }
      if (
        data.status === "done" ||
        data.status === "error" ||
        data.status === "not_found"
      ) {
        setStatus(data.status === "done" ? "done" : "error");
        messageApi[data.status === "done" ? "success" : "error"](
          data.status === "done"
            ? "Factura PDF este gata pentru descărcare."
            : "Eroare la generarea facturii PDF."
        );
        clearInterval(interval);
        setJobKey(null);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [jobKey]);

  const generateInvoices = async (all = false) => {
    setStatus("in_progress");
    const lastMonth = dayjs().subtract(1, "month")
    if(!date.isSame(lastMonth, "month")){
      return;
    }
    const response = await fetch(API_URL + "gestionar/invoice/pdf", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify({
        // addressId,
        startYear: lastMonth.year(),
        startMonth: lastMonth.month() + 1,
        endYear: lastMonth.year(),
        endMonth: lastMonth.month() + 1,
        all,
      }),
    });
    if (response.statusText !== "OK") {
      messageApi.error("Failed to generate PDF");
      setStatus("error");
      return;
    }
    const data = await response.json();
    setJobKey(data.jobKey);
  };

  async function downloadInvoices(contract) {
    const month = date.month() + 1;
    const year = date.year();
    try {
      const response = await fetch(
        `${API_URL}gestionar/invoice/download/${year}/${month}/${contract ?? ""}`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to download invoice");

      const contentType = response.headers.get("content-type");
      console.log({
        contentType,
        contLen: response.headers.get("content-length"),
      });
      // 🧩 Case 1: backend returned JSON (multiple ZIPs)
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();

        if (Array.isArray(data.files)) {
          for (const [i, file] of data.files.entries()) {
            setTimeout(() => {
              const a = document.createElement("a");
              a.href = file.url;
              a.download = file.name;
              document.body.appendChild(a);
              a.click();
              a.remove();
            }, i * 1000); // delay between downloads
          }
          return;
        }
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      const disposition = response.headers.get("content-disposition");
      console.log({ disposition });
      const match = disposition && disposition.match(/filename="?([^"]+)"?/);
      const filename = match
        ? match[1]
        : `invoices_${month}_${year}.zip`;

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
      messageApi.error("Nu există facturi")
    }
    
  }

  const columns = [
    {
      title: "CONTRACT",
      dataIndex: "CONTRACT",
      key: "CONTRACT",
      sorter: (a, b) => a.CONTRACT - b.CONTRACT,
      ...getColumnSearchProps("CONTRACT"),
    },
    {
      title: "ABON",
      dataIndex: "ABON",
      key: "ABON",
      sorter: (a, b) => a.ABON.localeCompare(b.ABON),
      ...getColumnSearchProps("ABON"),
    },
    {
      title: "Numarul de facturi in pdf/baza de date",
      dataIndex: "sumCount",
      key: "sumCount",
      sorter: (a, b) => a.sumCount - b.sumCount,
      ...getColumnSearchProps("nr_inv"),
      render: (text, record) => `${text}/${record.sumOriginalCount}`,
    },
    {
      title: "Actiuni",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          {/* <Button onClick={() => generateInvoices(record.id)}>Generate</Button> */}
          <Button
            disabled={status === "in_progress"}
            onClick={() => downloadInvoices(record.CONTRACT)}
          >
            Descărca
          </Button>
        </Space>
      ),
    },
  ];
  useEffect(() => {
    getCustomers();
  }, [date]);
  return (
    <div>
      {contextHolder}

      <Space direction="vertical" className="w-100">
        <div className="d-flex justify-content-between w-100">
          <DatePicker
            value={date}
            onChange={setDate}
            format={"MM-YYYY"}
            picker="month"
            disabledDate={(dt) => dt.isAfter(dayjs().subtract(1, "month"), "month")}
          />
          <Space>
            {jobKey || status === "in_progress" ? (
              <>
                <div className="status-container">
                  <span>Status: </span>

                  <span className={`status-text`}>
                    {status?.replace("_", " ")}
                  </span>
                  <span className={`status-text`}>
                    {percentage ? " / " + percentage + "%" : ""}
                  </span>
                </div>

                <div
                  style={{
                    width: "100px",
                    height: "12px",
                    border: "1px solid lightgray",
                    borderRadius: "20px",
                  }}
                >
                  <div
                    style={{
                      width: percentage ? percentage + "%" : "0%",
                      backgroundColor: "green",
                      height: "100%",
                      borderRadius: "20px",
                    }}
                  ></div>
                </div>
              </>
            ) : null}
            <Button
              disabled={status === "in_progress" || !date.isSame(dayjs().subtract(1, "month"), "month")}
              onClick={() => generateInvoices(true)}
            >
              Genera facturi
            </Button>
            <Button
              disabled={status === "in_progress"}
              onClick={() => downloadInvoices()}
            >
              Descărca toate
            </Button>
          </Space>
        </div>
        <Table
          locale={{
            triggerDesc: "Faceți clic pentru a sorta descrescător",
            triggerAsc: "Faceți clic pentru a sorta crescător",
            cancelSort: "Faceți clic pentru a anula sortarea",
            emptyText: <Empty description={"Nu există date"}></Empty>,
          }}
          scroll={{ x: 900 }}
          columns={columns}
          rowKey={"CONTRACT"}
          dataSource={customers}
        />
      </Space>
    </div>
  );
};
